export const DAYS_IN_MONTH = 30;
export const SECONDS_IN_DAY = 86400;
